'use client';
import React, { useRef, useState } from 'react';
import { withOptionalId } from '@lib/withOptionalId';
import {Card, AsideCollapsible, AsideCollapseFromMain, Heading} from '@ui';
import { Main, Section, Container } from '@layout';

type Props = {
  sectionID?: string;
  asideID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
};

const CollapsibleSidebar = ({
  isSpanish = false,
  sectionID = '',
  asideID,
  classes = '',
  containerId,
  containerClasses,
}: Props) => {
  const [open, setOpen] = useState(false);
  const openBtnRef = useRef<HTMLButtonElement | null>(null);
  const tc = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as="h3">
          {tc('Sidebar (Collapsible - Mobile & Tablet)', 'Barra lateral (plegable - móvil y tablet)')}
        </Heading>
        <p className='sub full'>
          {tc(
            'Responsive shell layout with a collapsible left nav. The aside is automatically hidden on mobile and tablet devices to free screen space. On desktop, the sidebar remains persistently visible.',
            'Diseño adaptable con una barra de navegación izquierda plegable. El aside se oculta automaticamente en dispositivos moviles y tablets para liberar espacio en pantalla. En escritorio, la barra lateral permanece visible de forma persistente.'
          )}
        </p>
        <p>{tc('A version of this component wraps this entire UI Kit page.', 'Una version de este componente envuelve toda la pagina del kit de UI.')}</p>

        <div className='with-sidebar sidebar-demo'>
          <AsideCollapsible
            open={open}
            onOpenChange={setOpen}
            openBtnRef={openBtnRef}
            menuTitle={tc('Menu', 'Menú')}
            asideID={asideID}
          />

          <Main className='main'>
            <AsideCollapseFromMain
              open={open}
              onOpenChange={setOpen}
              openBtnRef={openBtnRef}
              label={tc('☰ Menu', '☰ Menú')}
            />
            <div className='main-content'>
              <div className='grid-3'>
                <Card>
                  <b>{tc('Title', 'Titulo')}</b>
                  <div className='mt-8'>{tc('Placeholder content.', 'Contenido de ejemplo.')}</div>
                </Card>
                <Card>
                  <b>{tc('Title', 'Titulo')}</b>
                  <div className='mt-8'>{tc('Placeholder content.', 'Contenido de ejemplo.')}</div>
                </Card>
                <Card>
                  <b>{tc('Title', 'Titulo')}</b>
                  <div className='mt-8'>{tc('Placeholder content.', 'Contenido de ejemplo.')}</div>
                </Card>
              </div>
              <div className='mt-16'>
                <Card>
                  <b>{tc('Title', 'Titulo')}</b>
                  <div className='mt-8'>{tc('Placeholder content.', 'Contenido de ejemplo.')}</div>
                </Card>
              </div>
            </div>
          </Main>
        </div>
      </Container>
    </Section>
  );
};

export default CollapsibleSidebar;
